// Pure decision for which company should be the active one at app init.
//
// Extracted from App.jsx so the choice is unit-testable and so a re-init can
// never silently drop a multi-company user onto companyIds[0]. Preference
// order: the remembered selection, then whatever is already loaded, then the
// user's first company, then (admins only) the first company they can see.
//
// Every candidate except the final fallbacks is membership-validated by
// `canUse`, so a user removed from a company is never pinned to a stale one,
// while platform admins may sit in any company (their companyIds may be empty).
export const resolveActiveCompanyId = ({
  savedCompanyId,
  loadedCompanyId,
  userCompanyIds = [],
  isAdmin = false,
  adminCompanies = [],
} = {}) => {
  const canUse = (id) => !!id && (isAdmin || userCompanyIds.includes(id));

  if (canUse(savedCompanyId)) return savedCompanyId;   // remembered selection wins
  if (canUse(loadedCompanyId)) return loadedCompanyId; // else keep what's already loaded
  if (userCompanyIds[0]) return userCompanyIds[0];     // else the user's first company
  if (isAdmin && adminCompanies.length > 0) return adminCompanies[0].company.id; // admin, no companyIds
  return undefined;                                    // -> caller shows NO_COMPANY fatalError
};
